import React, {FC} from 'react';

import {useAppSelector} from 'store/config/hooks';
import {selectModalData, TModalComponentInterface} from 'store/slices/modals-slice';

import {FormModal} from './form-modal';

export const FormModalContainer: FC<TModalComponentInterface> = ({
    onClose,
}: TModalComponentInterface) => {
    const entityName = useAppSelector(state => selectModalData(state)?.entityName) || '';
    return (
        <FormModal
            entityName={entityName}
            onClose={onClose}
        />
    );
};
